module.exports = __webpack_public_path__ + "img/logoVital.1b9d424e.png";